module.exports = __webpack_public_path__ + "img/GreekTechMurderHoles_ua.1b1650c6.webp";